<template>
  <div class="app">
    <splitpanes class="default-theme">
      <pane size="22">
        <bd-aside></bd-aside>
      </pane>
      <pane size="43">
        <splitpanes horizontal>
          <pane size="6" min-size="6">
            <bd-top></bd-top>
          </pane>
          <pane size="77">
            <bd-message></bd-message>
          </pane>
          <pane size="17" min-size="17">
            <bd-input></bd-input>
          </pane>
        </splitpanes>
      </pane>
      <pane size="35">
        <bd-right></bd-right>
      </pane>
    </splitpanes>
  </div>
</template>

<script>
// https://antoniandre.github.io/splitpanes/
import { Splitpanes, Pane } from 'splitpanes'
import 'splitpanes/dist/splitpanes.css'
// import { mapGetters } from 'vuex'
// import { Layout } from 'vue-split-layout'
import BdAside from '@/components/dashboard/main/chat/BdAside'
// import BdMain from '@/components/dashboard/main/chat/BdMain'
import BdTop from '@/components/dashboard/main/chat/middle/BdTop'
import BdMessage from '@/components/dashboard/main/chat/middle/BdMessage'
import BdInput from '@/components/dashboard/main/chat/middle/BdInput'
import BdRight from '@/components/dashboard/main/chat/BdRight'
// import * as constants from '@/util/constants'

export default {
  name: 'bd-online',
  // BdToolbar, 
  components: { BdAside, BdTop, BdMessage, BdInput, BdRight, Splitpanes, Pane },
  // components: { BdAside, BdMain, Layout},
  data () {
    return {
      // resize: true,
      // layoutIM: {
      //   dir: 'horizontal',
      //   first: 0,
      //   second: 1,
      //   split: '20%'
      // },
      // layoutKF: {
      //   dir: 'horizontal',
      //   first: {
      //     dir: 'vertical',
      //     first: 0,
      //     // second: 1,
      //     split: '100%'
      //   },
      //   second: {
      //     dir: 'horizontal',
      //     first: 1,
      //     second: 2
      //   },
      //   split: '20%'
      // }
    }
  },
  computed: {
    // ...mapGetters([ 'userCurrentThread' ]),
    // showKeFu () {
    //   return this.userCurrentThread.type === constants.THREAD_TYPE_WORKGROUP ||
    //     this.userCurrentThread.type === constants.THREAD_TYPE_APPOINTED
    // },
    // layout () {
    //   return this.showKeFu ? this.layoutKF : this.layoutIM
    // }
  }
}
</script>

<style scope>
.bd-main {
  height: 100%;
  overflow: hidden;
}
.el-row {
  height: 100%;
}
/* .splitpanes.default-theme .splitpanes__pane {
  background-color: transparent;
}

.splitpanes.default-theme .splitpanes__splitter {
  background-color: transparent;
} */

/* .default-theme.splitpanes--vertical>.splitpanes__splitter,
.default-theme .splitpanes--vertical>.splitpanes__splitter {
  border-left: 1px solid #999;
}
.default-theme.splitpanes--horizontal>.splitpanes__splitter,
.default-theme .splitpanes--horizontal>.splitpanes__splitter {
  border-top: 1px solid #999;
} */
</style>
